export default "__VITE_ASSET__CNkrcSOF__"